import { configureStore } from "@reduxjs/toolkit";
import { selectedDistrictsReducer, selectedGenderReducer} from "./components/LandingPage/LandingPageSlice";
import { snackBarReducer } from "./components/CustomComponents/CustomComponentsSlice";

export const store = configureStore({
    reducer:{
        selectedDistricts: selectedDistrictsReducer,
        selectedGender: selectedGenderReducer,
        snackBar: snackBarReducer
    }
})